// extracted by mini-css-extract-plugin
export default {"container":"vl-z","blurb":"wl-z","links":"xl-z"};